import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import "./assets/theme/theme.scss";
import "utils/polyfills/arrayFrom";
import { ErrorBoundary, initializeSentry } from "utils/lib/sentry";

initializeSentry();

const container = document.getElementById("root");
if (container) {
  createRoot(container).render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
}

serviceWorker.unregister();
